import React, {useState} from 'react';
import {motion} from 'framer-motion';
import {Text} from '@tenancy.nz/design-system';

import AccordionList from '../../components/AccordionList';
import AccordionItem from '../../components/AccordionItem';
import ClientList from '../../components/ClientList';
import ContentImg from '../../components/ContentImg';
import LeftRightContent from '../../components/LeftRightContent';
import Link from '../../components/Link';
import Title from '../../components/Title';

import {URL_PRIVACY_POLICY} from '../../utils/constants';

import security from '../../assets/security.svg';
import faqs from '../../json/faqs.json';

function PrivacyFeature() {
  const [openedPanel, setOpenedPanel] = useState(null);
  const handlePanelToggle = panel => (_, isExpanded) =>
    setOpenedPanel(isExpanded ? panel : null);

  const subheading = (
    <span>
      You can find out Privacy Policy by <br /> clicking{' '}
      <Link color="secondary" underline="always" to={URL_PRIVACY_POLICY}>
        here
      </Link>
      .
    </span>
  );

  const renderAccordionItems = ({details, title}, i, type) => {
    const key = `${type}_panel${i}`;
    return (
      <motion.div
        animate={{
          opacity: 1,
          y: 0,
          transition: {
            ease: 'easeOut',
            delay: i * 0.1,
          },
        }}
        initial={{
          opacity: 0,
          y: 20,
        }}
        key={key}>
        <AccordionItem
          details={details}
          title={title}
          expanded={openedPanel === key}
          markdown
          onChange={handlePanelToggle(key)}
        />
      </motion.div>
    );
  };

  const content = (
    <>
      <Text as="div">
        <p>
          Below in simple terms is information about how we treat your data.
        </p>
      </Text>
      <AccordionList
        heading="Value"
        items={faqs.values}
        renderItem={(data, index) =>
          renderAccordionItems(data, index, 'values')
        }
        my={5}
      />
      <AccordionList
        heading="Protection"
        items={faqs.protection}
        renderItem={(data, index) =>
          renderAccordionItems(data, index, 'protection')
        }
        my={5}
      />
      <AccordionList
        heading="Choice"
        items={faqs.choice}
        renderItem={(data, index) =>
          renderAccordionItems(data, index, 'choice')
        }
        my={5}
      />
    </>
  );

  return (
    <>
      <Title text="Privacy - Tenant Portal" />
      <LeftRightContent
        heading="How we use your data"
        subheading={subheading}
        content={content}
        rightContent={<ContentImg animation="zoomIn" src={security} />}
      />
      <ClientList />
    </>
  );
}

export default PrivacyFeature;
